<template>
  <div class="achievments__wrapper">
    <div v-for="(item, index) in achievement" :key="index" class="achievments__wrapper-item">
      <p class="achievments-price" v-text="item.price" />
      <p class="achievments-title" v-text="item.title" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Achievments',
  data() {
    return {
      achievement: [
        {
          price: '4 450 ₽',
          title: 'Качество-стандарт',
        },
        {
          price: '5 959 ₽',
          title: 'Высокое качество',
        },
        {
          price: '2 дня',
          title: 'рабочих',
        },
      ],
    };
  },

  methods: {},
};
</script>
